import { Component } from '@angular/core';
import { TranslateDirective, TranslatePipe as NgxTranslatePipe } from '@ngx-translate/core';
import { HrefDirective } from '@tdwb/core';
import { ModalNotificationImageDirective } from '../../image/modal-notification-image.directive';

@Component({
  imports: [
    TranslateDirective,
    NgxTranslatePipe,
    HrefDirective,
    ModalNotificationImageDirective
  ],
  selector: 'td-wb-modal-notification-fractional-trading',
  templateUrl: 'modal-notification-fractional-trading.component.html',
  styleUrls: [
    '../modal-notification-common.component.scss'
  ]
})
export class ModalNotificationFractionalTradingComponent {
}
